import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import { ToastContainer } from './components/Toast';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Home from './pages/Home';
import Search from './pages/Search';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Profile from './pages/Profile';

const App = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = (message, type = 'info') => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-white dark:bg-dark">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home addToast={addToast} />} />
              <Route path="/search" element={<Search addToast={addToast} />} />
              <Route path="/login" element={<Login addToast={addToast} />} />
              <Route path="/signup" element={<Signup addToast={addToast} />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile addToast={addToast} />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <ToastContainer toasts={toasts} removeToast={removeToast} />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
